import { render, staticRenderFns } from "./checkout-form.vue?vue&type=template&id=f4542206&scoped=true"
import script from "./checkout-form.vue?vue&type=script&lang=js"
export * from "./checkout-form.vue?vue&type=script&lang=js"
import style0 from "./checkout-form.vue?vue&type=style&index=0&id=f4542206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4542206",
  null
  
)

export default component.exports